import FeaturedCourseSlider from '@/components/sliders/FeaturedCourseSlider'
import * as React from 'react'
declare const I18n;

type Course = {
  id: number
  title: string
  required_level: number
  active: boolean
  completed?: boolean
  lessons_completed?: number
  lessons_submitted?: number
  completed_lessons?: number
  total_lessons?: number
  progress?: number
  cover_image_data?: any
  description?: string
  type?: string
  is_deleted?: boolean
  language?: string
  created_at?: string
  updated_at?: string
}

type Props = {
  courses: Course[]
  userLevel?: number
  userType?: string
}

export const SuggestedCoursesContainer: React.FC<Props> = ({
  courses,
  userType,
  userLevel,
}) => {
  const isLearner = false;
  const isFacilitator = !!(userType && userType === 'Facilitator');

  if (courses && courses.length===0) return null

  return (
    <div>
      <FeaturedCourseSlider
        courses={[...new Map((courses || []).map(c => [c.id, c])).values()]}
        isFacilitator={!!(userType && userType === 'Facilitator')}
        isLearner={isLearner}
        learnerLevel={userLevel || 0}
        heading={I18n.t("models.course.messaging.recommended_course")} 
        viewAllText={I18n.t("models.course.messaging.view_all_courses")}
        viewAllUrl="/courses"
        emptyStateText={(isLearner || isFacilitator) ? I18n.t("models.course.messaging.no_course_in_progress") : I18n.t("models.course.messaging.no_course_available")}
        showProgress
        showBookIcon={false}
      />

      {/* Resources for You */}

    </div>
  )
}

export default SuggestedCoursesContainer